export class Generator {
    static GenAutoIncrementId() {
        return Generator.auto_increment_id++;
    }
}

Generator.auto_increment_id = 0;
//# sourceMappingURL=generator.js.map